import { Injectable, inject } from '@angular/core';
import { AmlScore } from '../../aml-score/aml-score-config/aml-score';
import { Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class AmlScoreService {
  private readonly commandEndpoint = `${environment.api}/prodotto-command/score/create-score-aml`;

  private readonly http = inject(HttpClient);
  constructor() {}

  getAmlScore(praticaId: string): Observable<AmlScore> {
    /* return of({
      praticaId: 'ObjectId',
      user: 'ObjectId',
      creationDate: 'YYYY-MM-DD',
      updateDate: 'YYYY-MM-DD',
      stato: 'APERTA', // APERTA || AUTORIZZATO || RIFIUTATO se aperto modificare score corrente else new score con versione +1
      scoreVersion: 0,
      overallEvaluation: 'HIGH',
      overallScore: 3085,
      sections: [
        {
          sectionScore: 1210,
          isAcceptable: true,
          weight: 100,
          id: 'CLIENTE',
          title: 'CLIENTE',
          elements: [
            {
              question: "Presente all'interno delle liste antiterrorismo",
              questionPoints: 100, //TODO CHECK IF NECESSARY
              questionWeight: 100,
              questionId: '10',
              responsePoints: 0,
              response: 'No',
              responseId: '26',
            },
          ],
        },
      ],
    }); */
    return this.http.post<AmlScore>(`${this.commandEndpoint}/${praticaId}`, {});
  }
}
